import { ConvertToManageFinanceAndJournals } from "@/helper/userHelper";
import textHelper from "../../helper/textHelper";

export function ConvertToUserDetailList(userDetailRawList: any) {
  const userDetailList = [];
  if (userDetailRawList && userDetailRawList.length > 0) {
    for (const userDetailRaw of userDetailRawList) {
      userDetailList.push({
        userId: userDetailRaw.userId,
        userEmail: userDetailRaw.userEmail,
        userType: userDetailRaw.userType,
        signatureUrl: userDetailRaw.signatureUrl,
        displayName: userDetailRaw.displayName,
        accountingFirmId: userDetailRaw.accountingFirmId,
        phone: userDetailRaw.phone,
        pictureUrl: userDetailRaw.pictureUrl,
        userName: userDetailRaw.userName,
      });
    }
  }
  return userDetailList;
}

export function ConvertToRegisterUserRequest(registerTemplate: any) {
  const encpw = textHelper.CreateToken(registerTemplate.password.value);
  const userProfileModel = {
    id: 0,
    username: registerTemplate.email.value,
    password: encpw,
    displayName: registerTemplate.firstName.value,
    firstName: registerTemplate.firstName.value,
    lastName: registerTemplate.lastName.value,
    phone: registerTemplate.telephone.value,
    referrerUserId: registerTemplate.referrerUserId,
    invitationId: registerTemplate.invitationId,
    invitationCode: registerTemplate.invitationCode,
    userRegisterOptionModel: {
      birthDate: !isNaN(new Date(registerTemplate.birthday.value).getDate()) ? registerTemplate.birthday.value : null,
      position: registerTemplate.position.value.value,
      positionOther: registerTemplate.addposition.value,
      department: registerTemplate.department.value.value,
      departmentOther: registerTemplate.adddepartment.value,
      file: registerTemplate.imageProfile,
    },
  };
  return userProfileModel;
}

export function PrepareToInsertUserProfileConsentModel(userprofileConsentModelInput: any) {
  const input = {
    userId: userprofileConsentModelInput.userId,
    isConsentTerm: userprofileConsentModelInput.isConsentTerm,
  };
  return input;
}

export function ConvertToUserDetail(_userDetail: any) {
  const userDetail = {
    userId: _userDetail.userId,
    email: _userDetail.email,
    firstName: _userDetail.firstName,
    lastName: _userDetail.lastName,
    phone: _userDetail.phone,
    merchantUserRoleType: _userDetail.merchantUserRoleType,
    manageUser: _userDetail.manageUser,
    manageFinance: _userDetail.manageFinance,
    isSuperUser: _userDetail.isSuperUser,
    isUsePayroll: _userDetail.isUsePayroll,
    isUsePeakBoard: _userDetail.isUsePeakBoard,
    manageProduct: _userDetail.manageProduct,
    userRoleModel: _userDetail.userRoleModel,
    authorityRole: _userDetail.authorityRole,
  };

  return userDetail;
}

export function ConvertToUserTemplateModel(userTemplate: any) {
  const userTemplateModel = {
    id: userTemplate.id,
    firstName: userTemplate.firstName.value,
    lastName: userTemplate.lastName.value,
    phone: userTemplate.phone.value,
    departmentId: userTemplate.department.value.value >= 0 ? userTemplate.department.value.value : null,
    departmentOther: userTemplate.departmentOther.value,
    positionId: userTemplate.position.value.value >= 0 ? userTemplate.position.value.value : null,
    positionOther: userTemplate.positionOther.value,
    birthDate:
      userTemplate.birthdate.value && !isNaN(new Date(userTemplate.birthdate.value).getTime())
        ? userTemplate.birthdate.value.ToDateJsonString()
        : null,
    pictureImg: {
      fileName: userTemplate.pictureImg.fileName,
      fileType: userTemplate.pictureImg.fileType,
      rawString: userTemplate.pictureImg.rawString,
      urlImg: userTemplate.pictureImg.urlImg,
    },
    signatureImg: {
      fileName: userTemplate.signatureImg.fileName,
      fileType: userTemplate.signatureImg.fileType,
      rawString: userTemplate.signatureImg.rawString,
      urlImg: userTemplate.signatureImg.urlImg,
    },
    isUpdatePictureImg: userTemplate.isUpdatePictureImg,
    isUpdateSignatureImg: userTemplate.isUpdateSignatureImg,
  };

  return userTemplateModel;
}
export function GetUserTableDetailList(userTableDetails: Array<any>) {
  const userTableDetailList: any = [];
  userTableDetails.forEach((item) => {
    userTableDetailList.push({
      authorityRole: item.authorityRole,
      manageFinanceAndJournals: ConvertToManageFinanceAndJournals(item.manageFinanceAndJournals),
      displayName: item.displayName,
      firstName: item.firstName,
      id: item.id,
      isManageFinance: item.isManageFinance,
      isManageProduct: item.isManageProduct,
      isManageUser: item.isManageUser,
      isSeeSelfDocuments: item.isSeeSelfDocuments,
      isSuperUser: item.isSuperUser,
      isUsePayroll: item.isUsePayroll,
      isUsePeakBoard: item.isUsePeakBoard,
      lastName: item.lastName,
      lastestActionDatetime: item.lastestActionDatetime,
      logoUrl: item.logoUrl,
      manageAsset: item.manageAsset,
      role: item.role,
    });
  });
  return userTableDetailList;
}

export function ConvertToUserTable(input: any) {
  const userTable: any = {
    isHaveSupportUser: input.isHaveSupportUser,
    userTableDetails: input.userTableDetails ? GetUserTableDetailList(input.userTableDetails) : [],
    allUserCount: input.alluserCount,
    lastestUpdateDatetime: input.lastestUpdateDatetime,
  };
  return userTable;
}

export function ConvertselectMerchantDetail(selectMerchant: any) {
  let selectMerchantDetail = null;
  if (selectMerchant) {
    selectMerchantDetail = {
      merchant: selectMerchant.merchant,
      role: {
        authorityRole: selectMerchant.role.authorityRole,
        isSeeSelfDocuments: selectMerchant.role.isSeeSelfDocuments,
        isSuperUser: selectMerchant.role.isSuperUser,
        isUsePayroll: selectMerchant.role.isUsePayroll,
        isUsePeakBoard: selectMerchant.role.isUsePeakBoard,
        manageAsset: selectMerchant.role.manageAsset,
        manageContact: selectMerchant.role.manageContact,
        manageFinance: selectMerchant.role.manageFinance,
        manageFinanceAndJournals: ConvertToManageFinanceAndJournals(selectMerchant.role.manageFinanceAndJournals),
        manageProduct: selectMerchant.role.manageProduct,
        manageUser: selectMerchant.role.manageUser,
        merchantId: selectMerchant.role.merchantId,
        role: selectMerchant.role.role,
      },
    };
  }
  return selectMerchantDetail;
}
